<div class="flex min-w-[350px] max-w-[350px] flex-col">
  <h2 class="mb-4">{{ "chat.labels.threads" | translate }}</h2>
  <div class="flex">
    <mat-form-field class="mr-3 w-full">
      <mat-icon
        matIconPrefix
        [fontIcon]="'search'"
      ></mat-icon>
      <mat-label>{{ "chat.labels.search" | translate }}</mat-label>
      <input
        matInput
        [formControl]="searchFc"
      />
    </mat-form-field>
  </div>

  <div class="max-h-[65vh] overflow-y-auto overflow-x-hidden">
    <div class="mr-3 flex flex-col gap-2">
      @for (thread of threads(); track thread.id) {
        <chat-thread
          [selected]="selectedThread()?.id === thread.id"
          [isOdd]="$odd"
          [unreadCount]="getUnreadCount(thread.id)"
          [thread]="thread"
          [ownUserId]="ownUserId()"
          (click)="onOpenThread(thread)"
          (pinThread)="onPinThread($event)"
          (unpinThread)="onUnpinThread($event)"
        ></chat-thread>
      } @empty {
        <div>{{ "chat.labels.empty" | translate }}</div>
      }
    </div>
  </div>
</div>
